/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    react/no-danger
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import * as ProtocolUtil from 'notebook/protocols/ProtocolUtil';
// @ts-expect-error
import CommentBus from 'notebook/protocols/viewer/CommentBus';
import CommentForm from 'notebook/protocols/viewer/CommentForm';
import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import * as DateUtil from 'util/DateUtil';

type Comment = any;

interface Props {
  id: number;
  commentBus: CommentBus;
  context?: string;
  created_at: string;
  creator: any;
  item_id: any;
  setActive?: (...args: Array<any>) => any;
  showContext: boolean;
  type: string;
  text: string;
  children: Array<Comment>;
}

type State = any;

class SingleComment extends React.Component<Props, State> {
  static defaultProps = {
    children: [],
    showContext: false,
  };

  state: State = {replying: false};

  deleteComment = (): void => {
    this.props.commentBus.deleteComment({
      commentID: this.props.id,
    });
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  openReply = () => {
    this.setState({replying: true});
    return typeof this.props.setActive === 'function' ? this.props.setActive() : undefined;
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  closeReply = () => {
    this.setState({replying: false});
    return this.props.commentBus.reflow();
  };

  render(): JSX.Element {
    const createdAt = DateUtil.readableTime(new Date(this.props.created_at));
    return (
      <div className="single-comment">
        {(() => {
          if (this.props.showContext && this.props.context) {
            const navID = ProtocolUtil.commentNavID(this.props.type, this.props.item_id);
            return (
              <a href={`#${navID}`} className="comment-context">
                <span className="in-response-to">Response to: </span>
                {this.props.context}
              </a>
            );
          }
          return null;
        })()}
        <div className="comment-author-img user-img">
          <img src={this.props.creator.avatar_url} width={32} height={32} />
        </div>
        <div className="comment-wrapper">
          <div className="comment-info">
            <div className="comment-author-name">{getPartyDisplayString(this.props.creator)}</div>
            <div className="comment-timestamp">{createdAt}</div>
          </div>
          <div
            className="comment-body"
            dangerouslySetInnerHTML={{
              __html: _.escape(this.props.text.trim()).replace(/\n/g, '<br>'),
            }}
          />
          {this.props.type !== 'comment' && this.props.commentBus.canComment ? (
            <a className="comment-reply" onClick={this.openReply}>
              Reply
            </a>
          ) : undefined}
          {this.props.commentBus.canDelete(this.props.creator) ? (
            <a className="comment-delete" onClick={this.deleteComment}>
              Delete
            </a>
          ) : undefined}
          {Array.from(this.props.children).map((childComment) => (
            <SingleComment
              // eslint-disable-next-line no-restricted-syntax
              {..._.extend({}, childComment, {
                key: childComment.id,
                commentBus: this.props.commentBus,
              })}
            />
          ))}
          {this.state.replying ? (
            <CommentForm
              linkableID={this.props.id}
              linkType="comment"
              onDescription={false}
              commentBus={this.props.commentBus}
              shouldFocus={true}
              canCancel={true}
              onSubmit={this.closeReply}
              onCancel={this.closeReply}
            />
          ) : undefined}
        </div>
      </div>
    );
  }
}

export default SingleComment;
